module.exports = __webpack_public_path__ + "static/media/D3.60d4b9f7.png";